import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Conf2SignInFailureReason } from "@youm-front/account/data-access";

/**
 * Terminal state for a failed conf2 (LiveE) sign-in. Without it the studio
 * waits for a token that never arrives and stays black.
 */
@Component({
  selector: "app-conf2-sign-in-failure",
  templateUrl: "./conf2-sign-in-failure.component.html",
  styleUrls: ["./conf2-sign-in-failure.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Conf2SignInFailureComponent {
  @Input() reason!: Conf2SignInFailureReason;

  readonly messages: Record<
    Conf2SignInFailureReason,
    { title: string; text: string }
  > = {
    "session-unavailable": {
      title: $localize`:@@conf2SignInFailure.sessionUnavailable.title:This session is not available.`,
      text: $localize`:@@conf2SignInFailure.sessionUnavailable.text:Please check the link or contact the organizer.`
    },
    unknown: {
      title: $localize`:@@conf2SignInFailure.unknown.title:Unable to join the session.`,
      text: $localize`:@@conf2SignInFailure.unknown.text:Please try again or contact the organizer.`
    }
  };

  get message() {
    return this.messages[this.reason] ?? this.messages.unknown;
  }
}
